import { TasksTaskStatusEnum, TasksValueObjectsTaskStatusEnum } from 'generated/resources/graphql'

import { TaskIdentifier } from 'modules/tasks/lib/task'

interface OverviewData {
  assigneeId: string
  dueInFuture: TasksTaskStatusEnum
  employeeIds: string[]
  identifier: TaskIdentifier
  inProgressStatus: TasksValueObjectsTaskStatusEnum
  noDueDate: TasksTaskStatusEnum
  overdue: TasksTaskStatusEnum
  toDoStatus: TasksValueObjectsTaskStatusEnum
  includeCost: boolean
}

export const overviewVariables = (
  currentUserId: string,
  employeeId: string,
  hasProjectCost: boolean
): OverviewData => {
  return {
    assigneeId: currentUserId,
    dueInFuture: 'due_in_future',
    employeeIds: [employeeId],
    identifier: TaskIdentifier.Project,
    inProgressStatus: 'in_progress',
    noDueDate: 'no_due',
    overdue: 'over_due',
    toDoStatus: 'todo',
    includeCost: hasProjectCost,
  }
}
